<template>
    <iframe class="w-full h-[400px]" src="https://www.google.com/maps/d/embed?mid=1llb0Ldu8IYXLOrxQrRqvHSC64v-mbuI3&ll=11.238605590180157%2C-60.68442105000001&z=12" />
</template>